/*
  TSi Shop : ouverture du méga menu au survol (souris uniquement).
  Le clic, le clavier et la fermeture restent gérés par Dawn (details-disclosure.js,
  <header-menu>). Un léger délai évite d'ouvrir un panneau en traversant la barre.
*/
(function () {
  var menu = document.querySelector('[data-tsi-menu]');
  if (!menu || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var DELAI_OUVERTURE = 120;
  var DELAI_FERMETURE = 200;
  var minuterie;
  var items = menu.querySelectorAll('.tsi-menu__item');

  function fermerTout(sauf) {
    menu.querySelectorAll('details[open]').forEach(function (d) {
      if (d === sauf) return;
      d.removeAttribute('open');
      d.querySelector('summary').setAttribute('aria-expanded', 'false');
    });
  }

  function ouvrir(details) {
    fermerTout(details);
    if (!details || details.open) return;
    details.setAttribute('open', '');
    details.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  items.forEach(function (item) {
    var details = item.querySelector('details');
    item.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(minuterie);
      // Une entrée sans panneau ferme le panneau ouvert
      minuterie = setTimeout(function () { details ? ouvrir(details) : fermerTout(null); }, menu.querySelector('details[open]') ? 0 : DELAI_OUVERTURE);
    });
    item.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(minuterie);
      minuterie = setTimeout(function () { fermerTout(null); }, DELAI_FERMETURE);
    });
  });

  // Échap ferme le panneau ouvert et rend le focus à son onglet
  menu.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var ouvert = menu.querySelector('details[open]');
    if (!ouvert) return;
    fermerTout(null);
    ouvert.querySelector('summary').focus();
  });
})();
